import { createAsyncThunk } from '@reduxjs/toolkit';
import { pipelineActions } from './pipelineReducers';
import { createApiAction } from '../shared/createApiAction';
import type { ApiRequestOptions, ThunkArgs } from '../shared/createApiAction';

// todo: need to update these, for now added some sample
const actionsConfig = {
  getKanbanInitialList: {
    method: 'post',
    endpoint: '/ats_jobs/:jobId/search/ats_applications/filter_by_stage',
    thunkName: 'kanbanInitialList',
    reducerName: 'kanbanInitialList',
    responseKey: 'data',
  },
  getRejectedCount: {
    method: 'post',
    endpoint: '/ats_jobs/:jobId/search/ats_applications/count',
    thunkName: 'rejectedCount',
    reducerName: 'rejectedCount',
    responseKey: 'data',
  },
};

const apiAction = createApiAction({ actions: pipelineActions });

export const pipelineApiActions = (
  actionId,
  config: ApiRequestOptions = {}
) => {
  // note: to use params, pass it directly inside requestConfig like below
  // requestConfig: { params: queryParams }
  const currentAction = actionsConfig[actionId];
  const { isApi } = config;
  if (!currentAction)
    return console.error('no actions config found for ats job create');

  const { endpoint, thunkName } = currentAction;

  if (isApi) {
    return (...args: ThunkArgs) => {
      return apiAction({ ...currentAction, endpoint }, config, args);
    };
  }

  return (...args: ThunkArgs) => {
    return createAsyncThunk(
      thunkName as string,
      // Pre-existing shape: a promise sits where a payload creator belongs.
      apiAction({ ...currentAction, endpoint }, config, args) as never
    );
  };
};
